import React, {useState, useEffect} from "react";
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDB} from "../../../constants/input-types";
import EditPanelInputText from '../components/EditPanelInputText';
import EditPanelInputTextArea from '../components/EditPanelInputTextArea';
import EditPanelInputSelect from '../components/EditPanelInputSelect';
import EditPanelInputSelectFromDb from '../components/EditPanelInputSelectFromDb';
import {DEFAULT_BLUE} from "../../../constants/general-constants";

export default function EditChildPanel({title, componentRows, clickChildCancel, clickChildSave, clickChildDelete}){
	
	
	useEffect(() => {
		
	}, [componentRows]);
	
	const mainEditPanel = {
		display:"flex",
		width:"100%",
		borderRadius:"4px",
		minHeight:"200px",
		flexDirection:"column"
	};
	
	const titlePanel = {
		display:'flex',
		width:"100%",
		alignItems:"center",
		justifyContent:"space-around",
		color:"black",
		height:"40px",
		fontSize:"14px"
	};
	
	const editRow = {
		display:"flex",
		minHeight:"40px",
		alignItems:"center"
	};
	
	const editTitle = {
		display:"flex",
		width:"150px",
		fontSize:"12px",
		paddingLeft:"20px"
	};
	
	const getInputDisplay = (inputType, ref, options, restUrl) => {
		if(inputType === INPUT_TYPE_TEXT){
			return <EditPanelInputText thisRef={ref}/>
		}	
		else if(inputType === INPUT_TYPE_TEXTAREA){
			return <EditPanelInputTextArea thisRef={ref}/>
		}	
		else if(inputType === INPUT_TYPE_SELECT){
			return <EditPanelInputSelect thisRef={ref} options={options}/>
		}	
		else if(inputType === INPUT_TYPE_SELECTFROMDB){
			return <EditPanelInputSelectFromDb thisRef={ref} options={options} restUrl={restUrl}/>
		}	
		
		else{
			return "n/a"
		}	
	};
	
	const componentRowDisplay = componentRows.map((item, index) => 
		<div style={editRow}>
			<div style={editTitle}>
				{item.title}
			</div>
			{getInputDisplay(item.inputType, item.ref, item.options, item.restUrl)}
		</div>
	);
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"20px",
		backgroundColor:DEFAULT_BLUE,
		borderRadius:"15px",
		color:"white",
		fontSize:"12px",
		cursor:"pointer",
		margin:"5px",
		alignItems:"center",
		justifyContent:"space-around",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
		marginTop:"6px"
	};
	
	const bottomBar = {
		display:"flex",
		width:"100%",
		height:"40px",
		backgroundColor:"black",
		alignItems:"center",
		justifyContent:"space-around",
		marginTop:"40px",
		alignSelf:"bottom"
	};
	
	const buttonContainer = {
		display:"flex"
	};
	
	return (
		<div style={mainEditPanel}>
			<div style={titlePanel}>
				{title}
			</div>
			{componentRowDisplay}
			<div style={bottomBar}>
				<div style={buttonContainer}>
					<div style={blueButton} onClick={clickChildCancel}>
						Cancel
					</div>
					<div style={blueButton} onClick={clickChildSave}>
						Save
					</div>
					<div style={blueButton} onClick={clickChildDelete}>
						Delete
					</div>
				</div>
			</div>
		</div>
		
	);
}